import React from "react";
import { Modal, Button } from "react-bootstrap";
import { Container, Row, Col, Card } from "react-bootstrap";
import { AiFillMessage } from "react-icons/ai";

import "./OfferDetailsModal.css";

const OfferDetailsModal = ({ show, handleClose, offerData, offerId }) => {
  const getFormatPrice = (amount) => {
    if (amount?.length === 0 || isNaN(amount)) {
      return "";
    }
    return amount?.toString().replace(/(\d)(?=(\d\d\d)+(?!\d))/g, "$1,");
  };
  

  return (
    <Modal show={show} onHide={handleClose} size="lg" className="">
      <Modal.Header
        closeButton
        className="border-bottom py-3 add-agent-license"
      >
        <Modal.Title className="p-1 mb-0 add-agent-license-title roboto-regular">
          Offer Details
        </Modal.Title>
      </Modal.Header>
      <Modal.Body>
        <div className="sectionContainer pt20">
          <Row xs={12} md={12}>
            <Col xs={6} md={6}>
              <div className=" row">
                <p className="detail-label-aution">Property Id: </p>
                <p className="detail-value">{" " + offerData?.propertyId}</p>
              </div>
            </Col>
            <Col xs={6} md={6}>
              <div className=" row">
                <p className="detail-label-aution">Offer Amount: </p>
                <p className="detail-value">
                  {" $" +
                    getFormatPrice(
                      offerData?.negotiationList?.[0]?.offerAmount
                    )}
                </p>
              </div>
            </Col>
          </Row>
          <Row>
            <Col xs={6} md={6}>
              <div className=" row">
                <p className="detail-label-aution">Offer Id: </p>
                <p className="detail-value">{" " + offerData?.id}</p>
              </div>
            </Col>
            <Col xs={6} md={6}>
              <div className=" row">
                <p className="detail-label-aution">Offer Date: </p>
                <p className="detail-value">
                  {" " + offerData?.formattedSubbmittedDate}
                </p>
              </div>
            </Col>
          </Row>
        </div>

        <div className="seperator-auction prpl20"></div>
        <p className="headingTitle-aution mt-3">Financing Information</p>

        <div className="flex-container mb-3">
          {offerData?.paymentType && (
            <div className="flex-item d-flex">
              <p className="detail-label-aution">Payment Method:</p>
              <p className="detail-value">
                {" " +
                  offerData?.paymentType?.charAt(0)?.toUpperCase() +
                  offerData?.paymentType?.slice(1)?.toLowerCase()}
              </p>
            </div>
          )}

          {offerData?.closingDaysSelected && (
            <div className="flex-item d-flex">
              <p className="detail-label-aution">Must Close Within:</p>
              <p className="detail-value">
                {offerData?.closingDaysSelected + " Day(s)"}
              </p>
            </div>
          )}

          <div className="flex-item d-flex">
            <p className="detail-label-aution">Offer Valid for:</p>
            <p className="detail-value">
              {offerData?.negotiationExpiryDays + " Day(s)"}
            </p>
          </div>
  {offerData?.loanAmount && offerData?.paymentType === "MORTGAGE" && (
            <div className="flex-item d-flex">
              <p className="detail-label-aution">Loan Amount:</p>
              <p className="detail-value">
                ${getFormatPrice(offerData?.loanAmount)} (100.00%)
              </p>
            </div>
          )}
            {offerData?.negotiationList?.[0].contingencyList ===
            null && (
            <div className="flex-item d-flex">
              <p className="detail-label-aution">Offer Contingent On:</p>
              <p className="detail-value">No</p>
            </div>
          )} 
            {offerData?.paymentType === "MORTGAGE" && (
            <div className="flex-item d-flex">
              <p className="detail-label-aution">Pre Approved for Finance:</p>
              <p className="detail-value">
                {offerData?.preApprovalDetail?.isPreApprovedForFinance
                  ? "Yes"
                  : "No"}
              </p>
            </div>
          )}
          <div className="flex-item d-flex">
            <p className="detail-label-aution">Have you Toured the Property?:</p>
            <p className="detail-value">
              {offerData?.propertyVisted === true ? "Yes" : "No"}
            </p>
          </div>
        </div>

        {offerData?.negotiationList?.[0].contingencyList?.length > 0 && (
          <>
            <div className="seperator-auction prpl20"></div>
            <p className="headingTitle-aution mt-3">Seller Contingencies</p>
          <div className="mb-3">

            {offerData?.negotiationList?.[0].contingencyList?.map(
              (item, index) => (
                <div key={index}>
                  <p className="contingenciesText">
                    {" \u2022   " + item?.comment}
                  </p>
                </div>
              )
            )}
          </div>
          </>
        )}
        {offerData?.negotiationList?.[0].sellerContributionList?.length > 0 && (
          <>
            <div className="seperator-auction prpl20 mt-3"></div>
            <p className="headingTitle-aution">Seller Concessions</p>

            {offerData?.negotiationList?.[0].sellerContributionList?.map(
              (item, index) => (
                // <div key={index} className="d-flex justify-content-between py-3">
                //   <p className="detail-label-aution w-25">
                //     {"    " + item?.contributionDesc}
                //   </p>
                //   <p className="detail-value">
                //      {" $" +
                //     getFormatPrice(
                //       item?.contributionAmount
                //     )}
                //   </p>
                //   <p className="detail-label-aution">
                //   {
                //     item?.additionalNote &&
                //     <>
                //     {"  " + item?.additionalNote}
                //     </>
                //   }
                //   </p>
                // </div>
                <div key={index} className="d-flex justify-content-between py-3">
      <div className="w-25">
        <p className="detail-label-aution">
          {"    " + item?.contributionDesc}
        </p>
      </div>
      <div className="text-end" style={{minWidth: '100px'}}>
        <p className="detail-value">
          {" $" + getFormatPrice(item?.contributionAmount)}
        </p>
      </div>
      <div className="flex-grow-1 mx-5">
        <p className="detail-label-aution">
          {item?.additionalNote ? "  " + item?.additionalNote : ""}
        </p>
      </div>
    </div>
              )
            )}
         <div className="d-flex justify-content-between pb-3 total-row-linr">
  <div className="w-25">
    <p className="detail-label-aution">Total</p>
  </div>
  <div className="text-end" style={{minWidth: '100px'}}>
    <p className="detail-value">
      {" $" + getFormatPrice(offerData?.negotiationList?.[0]?.totalContributionsCost)}
    </p>
  </div>
  <div className="flex-grow-1"></div>
</div>
          </>
        )}
        <div className="seperator-auction prpl20"></div>

        <div className="offer-activity">
          <div className="acitivity-heading">
            <p className="acitivity-heading-p">
              <AiFillMessage className="mx-2 fs24" />
              Offer Activities
            </p>
            <span className="text-end">+</span>
          </div>
          <p className="note-auction">
           Note:  An earnest money deposit of $
            {getFormatPrice(
              offerData?.negotiationList?.[0]?.offerDepositAmount
            )}{" "}
            is due after you sign the Purchase & Sale Agreement. A technology
            fee of ${getFormatPrice(offerData?.technologyFees)} is applicable.
          </p>
        </div>

        {/* <div className="mt-4 d-flex justify-content-end">
                    <Button variant="secondary" onClick={handleClose}>
                        Close
                    </Button>
                </div> */}
      </Modal.Body>
    </Modal>
  );
};

export default OfferDetailsModal;
